import { HttpErrorResponse } from "@angular/common/http";

const ActionTypes = {
    GET_PERSON_DETAILS: '[Persons] Get Person Details',
    GET_PERSON_DETAILS_SUCCESS: '[Persons] Get Person Details Success',
    GET_PERSON_DETAILS_FAIL: '[Persons] Get Person Details Fail',
    GET_PERSON_DETAILS_STREAM: '[Persons] Get Person Details Stream',
}

export class GetPersonDetails {
    static type = ActionTypes.GET_PERSON_DETAILS;
    constructor(public payload: {dataId: string, localRequestId: string}) {} // payload is the dataId of the person
}

export class GetPersonDetailsSuccess {
    static type = ActionTypes.GET_PERSON_DETAILS_SUCCESS;
    constructor(public payload: any, public metadata: {dataId: string, localRequestId: string}) {} // payload is the person details
}

export class GetPersonDetailsFail {
    static type = ActionTypes.GET_PERSON_DETAILS_FAIL;
    constructor(public payload: HttpErrorResponse) {} // payload is the error response
}

export class GetPersonDetailsStream {
    static type = ActionTypes.GET_PERSON_DETAILS_STREAM;
    constructor(public payload: {hash: string, dataId: string, localRequestId: string}) {} // payload is the dataId of the person
}